/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

export const COLUMNS = [
  {
    Header: "Booking Code",
    accessor: "BookingCode"
  },
  {
    Header: "Description",
    accessor: "Description"
  },
  {
    Header: "Multiple Days",
    accessor: "MultiDay"
  },
  {
    Header: "Active",
    accessor: "Active"
  },
  {
    Header: "BOOKCATG",
    accessor: "BookingCategory",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : "")
  },
  {
    Header: "Color",
    accessor: "Color",
    id: "Color",
    Cell: ({ cell }) => (
      <span
        style={{
          color: cell.value,
          fontWeight: "bolder",
          textTransform: "uppercase"
        }}
      >
        {cell.value}
      </span>
    )
  }
];
